import { GenericFeedbackForm } from '../../components/Feedback/FeedbackForm'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router'
import { FeedbackForm } from '../../context/useFeedback'
import { Card } from '../../components/Layout/Card'
import styled from 'styled-components'
import { breakpoints } from '@spritz-finance/ui'

const FeedbackCard = styled(Card)`
    min-width: 560px;
    min-height: 200px;
    padding: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    ${breakpoints.small} {
        min-width: 75vw;
    }
`

export default function FeedbackPage() {
    const navigate = useNavigate()
    const location = useLocation()

    const onSubmit = () => {
        navigate('/home')
    }

    let formId: FeedbackForm
    if (location.search.match(/form=payment$/)) {
        formId = FeedbackForm.NoPayment
    } else if (location.search.match(/form=email$/)) {
        formId = FeedbackForm.EmailNotHelpful
    } else {
        formId = FeedbackForm.GenericFeedback
    }

    return (
        <FeedbackCard>
            <GenericFeedbackForm formId={formId} onSubmitForm={onSubmit} />
        </FeedbackCard>
    )
}
